module.exports = __webpack_public_path__ + "img/DSC_0180 teatro ilpa aire libre_thumb.9dcfa12b.jpg";